'use client';

import type { TypingUser } from '@/hooks/use-chat-stream';

interface TypingIndicatorProps {
  users: TypingUser[];
}

export function TypingIndicator({ users }: TypingIndicatorProps) {
  if (users.length === 0) return null;

  const names =
    users.length === 1
      ? users[0].display_name
      : users.length === 2
        ? `${users[0].display_name} and ${users[1].display_name}`
        : `${users[0].display_name} and ${users.length - 1} others`;

  return (
    <div className="px-4 py-1 text-xs text-muted-foreground/70 flex items-center gap-1 shrink-0">
      <span className="inline-flex gap-0.5">
        <span className="animate-bounce [animation-delay:0ms] h-1 w-1 rounded-full bg-muted-foreground/50" />
        <span className="animate-bounce [animation-delay:150ms] h-1 w-1 rounded-full bg-muted-foreground/50" />
        <span className="animate-bounce [animation-delay:300ms] h-1 w-1 rounded-full bg-muted-foreground/50" />
      </span>
      <span className="truncate max-w-[200px]">{names}</span>
      <span>{users.length === 1 ? 'is' : 'are'} typing</span>
    </div>
  );
}
